var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04757 0L8.78097 2.36338C7.07631 2.84406 5.6888 3.98569 5.6888 5.68813C5.6888 7.51073 7.09613 8.65236 9.1774 8.73247C9.1774 11.6567 7.45292 14 4.57879 14C1.82359 14 0 11.8569 0 8.69242C0 4.10587 3.7661 1.04149 8.04757 0ZM18.8702 0L19.6036 2.36338C17.8989 2.84406 16.5114 3.98569 16.5114 5.68813C16.5114 7.51073 17.9187 8.65236 20 8.73247C20 11.6567 18.2755 14 15.4014 14C12.6462 14 10.8226 11.8569 10.8226 8.69242C10.8226 4.10587 14.5887 1.04149 18.8702 0Z",
    fill: "#00CE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.de1f9dcefb1a32bcff397cdcae245a6d.svg";
export { ForwardRef as ReactComponent };